import { MenuItem, Select } from '@material-ui/core';
import { isMemberTitle, MEMBER_TITLE_OPTIONS, MemberTitle } from '../../../utils/memberTitles';

export interface MemberTitleSelectProps {
  value?: MemberTitle;
  onChange: (value: MemberTitle | undefined) => void;
  /** Accessible name, since this renders inline with no visible <label> (e.g. "Tag for jane-doe"). */
  ariaLabel: string;
}

/** Compact per-row selector for the optional Designer/Project Manager/Analyst tag (PAT-857). */
export function MemberTitleSelect({ value, onChange, ariaLabel }: MemberTitleSelectProps) {
  // An older/hand-edited entity could carry a value outside MEMBER_TITLE_LABELS —
  // fall back to the empty option rather than passing it through to MUI, which
  // warns on an out-of-range Select value.
  const knownValue = isMemberTitle(value) ? value : '';
  return (
    <Select
      value={knownValue}
      onChange={e => onChange((e.target.value as MemberTitle) || undefined)}
      displayEmpty
      margin="dense"
      style={{ minWidth: 140, marginRight: 4 }}
      inputProps={{ 'aria-label': ariaLabel }}
    >
      <MenuItem value="">—</MenuItem>
      {MEMBER_TITLE_OPTIONS.map(([titleValue, label]) => (
        <MenuItem key={titleValue} value={titleValue}>
          {label}
        </MenuItem>
      ))}
    </Select>
  );
}
